Turbo.StreamActions.refresh_frame = function refreshFrameStreamAction(){
  this.targetElements.forEach(el => {
    const src = el.dataset.refreshSrc || el.getAttribute("src")
    if(!src) return;
    el.src = src;
  })
}